import { jsx as l, jsxs as m } from "react/jsx-runtime";
import { ColorPicker as p, Tooltip as x, NeutralButton as y, NeutralTypeEnum as A, PrimaryButton as E } from "@systemeio/ui";
import { useEditorState as I } from "../../node_modules/@tiptap/react/dist/index.mjs";
import { useMemo as w } from "react";
import { twMerge as C } from "tailwind-merge";
import { DEFAULT_BG_COLOR as L, getToolbarIconClassName as b, TOOLBAR_BUTTON_CLASSNAMES as h, getToolbarCaptionClassName as O, TOOLTIP_STYLES as _ } from "../../constants/default-styles.mjs";
import f from "../../icons/highlighter-icon.mjs";
import { useTranslation as F } from "../../i18n.mjs";
import { FocusTrapFeatures as T, FocusTrap as P } from "@headlessui/react";
import { normalizeToHex as S } from "@systemeio/util";
import { isImageSelected as R } from "../image-extension/utils/is-image-selected.mjs";
const V = (a, k) => {
  const { t: c } = F(), { shouldHideTooltip: d, showAlpha: u = !0 } = k ?? {}, r = I({
    editor: a,
    selector: ({ editor: o }) => ({
      isEditable: (o == null ? void 0 : o.options.editable) ?? !1,
      backgroundColor: o == null ? void 0 : o.getAttributes("textStyle").backgroundColor,
      isImageSelected: R(o)
    })
  }), i = r == null ? void 0 : r.backgroundColor, s = i ? S(i) : L, n = !(r != null && r.isEditable) || !!(r != null && r.isImageSelected), t = !!i;
  return w(() => {
    const o = (e) => {
      if (!a) return null;
      a.chain().setBackgroundColor(e).run();
    }, N = (e) => {
      if (!a) return null;
      const v = e() ?? s;
      a.chain().focus().setBackgroundColor(v).run();
    }, B = () => {
      if (!a) return null;
      a.chain().focus().unsetBackgroundColor().run();
    }, g = (e) => /* @__PURE__ */ l(P, { features: T.None, children: /* @__PURE__ */ m("div", { className: "flex gap-3", children: [
      /* @__PURE__ */ l(
        y,
        {
          className: "w-full",
          neutralType: A.danger,
          disabled: !t,
          onClick: B,
          children: c("global.clear")
        }
      ),
      /* @__PURE__ */ l(
        E,
        {
          className: "w-full",
          onClick: () => N(e),
          children: c("global.apply")
        }
      )
    ] }) });
    return {
      toolbarRender: /* @__PURE__ */ l(
        p,
        {
          disabled: n,
          additionalPopoverChildren: (e) => g(e),
          color: s,
          onChange: o,
          showAlpha: u,
          children: () => /* @__PURE__ */ l(
            x,
            {
              disabled: d || n,
              label: c("background_color"),
              ..._,
              children: /* @__PURE__ */ m(
                "div",
                {
                  className: C(
                    h,
                    "main-transition-colors gap-1.5",
                    "relative"
                  ),
                  children: [
                    /* @__PURE__ */ l(f, { className: b(n) }),
                    t && /* @__PURE__ */ l(
                      "div",
                      {
                        className: "absolute bottom-0 h-1 w-4 rounded-lg",
                        style: { backgroundColor: s }
                      }
                    )
                  ]
                }
              )
            }
          )
        }
      ),
      tooltipRender: /* @__PURE__ */ l(
        p,
        {
          disabled: n,
          focusTrapFeatures: T.FocusLock,
          additionalPopoverChildren: (e) => g(e),
          color: s,
          onChange: o,
          showAlpha: u,
          children: () => /* @__PURE__ */ m(
            "div",
            {
              className: C(
                h,
                "gap-1.5",
                "relative",
                "flex gap-1",
                O(n)
              ),
              children: [
                /* @__PURE__ */ l(f, { className: b(n) }),
                c("background_color"),
                t && /* @__PURE__ */ l(
                  "div",
                  {
                    className: "absolute right-0 h-1.5 w-1.5 rounded-full",
                    style: { backgroundColor: s }
                  }
                )
              ]
            }
          )
        }
      )
    };
  }, [s, a, t, n, d, u, c]);
};
export {
  V as useTextBackgroundColorExtensionToolbar
};
